(() => {
  const initialiseHub = (hub) => {
    const controls = hub.querySelector('[data-guide-controls]');
    const search = hub.querySelector('[data-guide-search]');
    const filters = [...hub.querySelectorAll('[data-guide-filter]')];
    const cards = [...hub.querySelectorAll('[data-guide-grid] [data-guide-card]')];
    const results = hub.querySelector('[data-guide-results]');
    const empty = hub.querySelector('[data-guide-empty]');

    if (!controls || !search || filters.length === 0 || cards.length === 0) return;

    let activeCategory = 'all';
    const normalise = (value) => String(value || '').trim().toLowerCase();

    const update = () => {
      const query = normalise(search.value);
      let visibleCount = 0;

      cards.forEach((card) => {
        const categories = normalise(card.dataset.guideCategories).split(/\s+/).filter(Boolean);
        const searchableText = normalise(card.dataset.guideSearchText);
        const categoryMatches = activeCategory === 'all' || categories.includes(activeCategory);
        const searchMatches = query === '' || searchableText.includes(query);
        const isVisible = categoryMatches && searchMatches;
        card.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      if (results) {
        results.textContent = `${visibleCount} ${visibleCount === 1 ? 'guide' : 'guides'} shown`;
        results.hidden = activeCategory === 'all' && query === '';
      }
      if (empty) empty.hidden = visibleCount !== 0;
    };

    filters.forEach((button) => {
      button.addEventListener('click', () => {
        activeCategory = button.dataset.guideFilter || 'all';
        filters.forEach((candidate) => {
          const selected = candidate === button;
          candidate.classList.toggle('is-active', selected);
          candidate.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        update();
      });
    });

    search.addEventListener('input', update);
    controls.hidden = false;
    update();
  };

  const start = () => document.querySelectorAll('[data-guides-hub]').forEach(initialiseHub);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
